import React from 'react';
import { Form, Field } from 'react-final-form';
import InputField from '../../Pages/Login/InputField';
import Dropzone from './Dropzone';
import uri from './constants';
import axios from 'axios';


const submit = async (values, setAuthenticated, setToken) => {
  await axios.post(
    `${uri}/unicef/authenticate/`,
    values
  )
    .then((response) => {
      setAuthenticated(true);
      setToken(response.data.token);
    })
    .catch((error) => {
      alert('Usuário não autenticado!');
    })
}

const AuthForm = ({ setAuthenticated, setToken }) => (
  <Form
    onSubmit={async (values) => submit(values, setAuthenticated, setToken)}
    render={({ handleSubmit, submitting }) => (
      <form onSubmit={handleSubmit}>
        <div className="pl-lg-4">
          <div className="row">
            <div className="col-12 col-md-12">
              <div className="form-group">
                <Field
                  placeholder="Usuário"
                  name="username"
                  type="text"
                  label="Usuário"
                  component={InputField}
                  icon="ni-circle-08"
                />
              </div>
              <div className="form-group">
                <Field
                  placeholder="Senha"
                  name="password"
                  type="password"
                  label="Senha"
                  component={InputField}
                  icon="ni-lock-circle-open"
                />
              </div>
            </div>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-success mt-4"
              disabled={submitting}
            >
              {submitting ? 'Autenticando, aguarde...' : 'Enviar'}
            </button>
          </div>
        </div>
      </form>
    )}
  />
);

export default AuthForm;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/AuthForm.js